import { Route, Routes } from 'react-router'
import { AppLayout } from '@/components/AppLayout'
import { RequireAuth } from '@/components/RequireAuth'
import { AccountPage } from '@/pages/AccountPage'
import { DashboardPage } from '@/pages/DashboardPage'
import { GuidesPage } from '@/pages/GuidesPage'
import { InvitePage } from '@/pages/InvitePage'
import { LoginPage } from '@/pages/LoginPage'
import { NotFoundPage } from '@/pages/NotFoundPage'
import { RequestsPage } from '@/pages/RequestsPage'
import { AdminActivityPage } from '@/pages/admin/AdminActivityPage'
import { AdminAnnouncePage } from '@/pages/admin/AdminAnnouncePage'
import { AdminDownloadsPage } from '@/pages/admin/AdminDownloadsPage'
import { AdminInvitesPage } from '@/pages/admin/AdminInvitesPage'
import { AdminLayout } from '@/pages/admin/AdminLayout'
import { AdminProfilesPage } from '@/pages/admin/AdminProfilesPage'
import { AdminUsersPage } from '@/pages/admin/AdminUsersPage'

export function App() {
  return (
    <Routes>
      {/* Public: reachable during an outage and before sign-in. */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/invite/:code" element={<InvitePage />} />

      <Route
        element={
          <RequireAuth>
            <AppLayout />
          </RequireAuth>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="requests" element={<RequestsPage />} />
        <Route path="account" element={<AccountPage />} />
        <Route path="guides" element={<GuidesPage />} />

        <Route path="admin" element={<AdminLayout />}>
          <Route index element={<AdminUsersPage />} />
          <Route path="invites" element={<AdminInvitesPage />} />
          <Route path="profiles" element={<AdminProfilesPage />} />
          <Route path="downloads" element={<AdminDownloadsPage />} />
          <Route path="activity" element={<AdminActivityPage />} />
          <Route path="announce" element={<AdminAnnouncePage />} />
        </Route>

        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  )
}
